import { Input } from "antd";
import { InputWrapper, TextAreaWrapper } from "./styles/input.style";
import WithDirection from "../misc/theme/withDirection";

const { TextArea } = Input;

const WDStyledInput = InputWrapper(Input);
const StyledInput = WithDirection(WDStyledInput);

const WDTextarea = TextAreaWrapper(TextArea);
const Textarea = WithDirection(WDTextarea);

export default StyledInput;
export { Textarea };



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/input.js